export const LIQUIMASTER_APP_URL =
  import.meta.env.VITE_LIQUIMASTER_APP_URL || "http://localhost:5173/";

export const API_URL =
  import.meta.env.VITE_API_URL || "http://localhost:8080";
